export default __webpack_public_path__ + "static/media/archived_prospects.93996de7.png";